/*
 * @Author: lbh
 * @Date: 2020-12-24 18:12:01
 * @LastEditors: lbh
 * @LastEditTime: 2021-12-01 12:23:33
 * @Description: 地址相關請求
 */
import axios from "../../util/http";
let origin = axios.host();
let memberWeb = origin + "/member-web/api";
/**
 * 接口描述
 * @param {
 *  aa='意義',
 *  bb='意義'
 * } params
 * @returns
 */
export const testGet = params => axios.get(memberWeb + "/xx/xx/xx", params);
// 獲取地址列表
export const getMemberAddress = params =>
  axios.post(memberWeb + "/member/getMemberAddress", params);

// 添加地址
export const addMemberAddress = params =>
  axios.post(memberWeb + "//member/addMemberAddress", params);

// 修改地址
export const updateMemberAddress = params =>
  axios.post(memberWeb + "/member/updateMemberAddress", params);

// 刪除 地址
export const delMemberAddress = params =>
  axios.post(memberWeb + "/member/delMemberAddress", params);
